import type { SVGProps } from 'react';
const DawnFlagPW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-PW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-PW_svg__a)">
      <path fill="#65C6EE" d="M0 0h22v16H0z" />
      <path
        fill="#FFE044"
        fillRule="evenodd"
        d="M9.953 12.8c2.603 0 4.714-2.15 4.714-4.8s-2.11-4.8-4.714-4.8S5.238 5.349 5.238 8s2.11 4.8 4.715 4.8"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagPW;
